import { Info } from 'lucide-react';
import type { ReactNode } from 'react';

/** Shown when a minigame challenge is missing the config it needs to play. */
export function DemoNotConfigured({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-start gap-2 rounded-2xl border bg-muted/30 p-5 text-sm text-muted-foreground">
      <Info className="mt-0.5 h-4 w-4 shrink-0" />
      <span>{children}</span>
    </div>
  );
}
